module.exports = __webpack_public_path__ + "img/respecth-login.fc02004c.png";